import { render, staticRenderFns } from "./ContainPeanutIcon.vue?vue&type=template&id=36c4e1e7&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports